import { inject } from '@angular/core';

import { UrlParamsKeys } from '@config/keys/url-params.keys';
import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';
import { Cb2PreviewBootService } from '@core/services/cb2-preview/cb2-preview-boot.service';

/**
 * Activates the CB2 preview mode + arms the boot listener BEFORE the
 * `ensureMarketplaceIsLoaded` APP_INITIALIZER runs.
 *
 * `MarketplaceService.loadMarketplace$` reads `Cb2PreviewStateService.isActive`
 * to decide whether to skip the domain API, and awaits
 * `Cb2PreviewBootService.waitForInitialPayload` for the dashboard stub. Both
 * must be ready before that initializer resolves, hence this dedicated
 * initializer registered first in `AppModule`.
 *
 * Must be listed BEFORE `ensureMarketplaceIsLoaded` in the providers array.
 */
export function activateCb2PreviewMode(): () => void {
  return () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    if (!urlSearchParams.has(UrlParamsKeys.CbPreview)) return;

    const previewState = inject(Cb2PreviewStateService);
    const boot = inject(Cb2PreviewBootService);

    previewState.activate();
    boot.registerListener();
  };
}
